import React, {useContext, useState} from 'react';
import {Button, Col, FormGroup, Label, Row} from "reactstrap";
import Field from "../../Field";
import {emailvalidate, required, strongPassword} from "../../Field/validate";
import {Formik} from "formik";
import axios from "axios";
import {handleError, showsuccesToast} from "../../HandleError";
import localized from '../../../i18n';
import authContext from "../../../AuthProvider/authContext";

const PersonalInfo = ({user}) => {
    const {getAuthenticatedUser} = useContext(authContext);
    const updateProfile = (values, setSubmitting) => {
        setSubmitting(true);
        axios.post("/api/edit-profile", values)
            .then((response) => {
                setSubmitting(false);
                getAuthenticatedUser();
                showsuccesToast(localized.personal_info_updated_successfully);
            }).catch((err) => {
            setSubmitting(false);
            handleError(err);
        })
    }
    const [showPassword,setShowPassword] = useState({
        oldPassword:false,
        newPassword:false,
        confirmPassword:false,
    });

    const togglePassword = (field = "oldPassword") => {
        setShowPassword((prev)=>({
            ...prev,[field]:!showPassword[field]
        }))
    }
    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                first_name: user.email ? user.first_name : "",
                last_name: user.email ? user.last_name : "",
                email: user.email ? user.email : "",
                current_password: "",
                new_password: "",
                confirm_password: "",
            }}
            onSubmit={(values, {setSubmitting}) => updateProfile(values, setSubmitting)}
        >
            {props => {
                const {handleSubmit,isSubmitting} = props;
                return (
                    <form onSubmit={handleSubmit} className="theme-form">
                        <div className="setting-profile-input">
                            <h2>{localized.Details}</h2>
                            <Row>
                                <Col sm={12} md={6}>
                                    <Field
                                        label={localized.first_name}
                                        name="first_name"
                                        type="text"
                                        placeholder='First name'
                                        validate={required}
                                    />
                                </Col>
                                <Col sm={12} md={6}>
                                    <Field
                                        label={localized.last_name}
                                        name="last_name"
                                        type="text"
                                        placeholder='First name'
                                        validate={required}
                                    />
                                </Col>
                            </Row>
                            <Row className={"align-items-center"}>
                                <Col sm={12} md={6}>
                                    <Field
                                        label={localized.email}
                                        name="email"
                                        type="email"
                                        placeholder='Email'
                                        validate={emailvalidate}
                                        disabled={true}
                                    />
                                </Col>
                                <Col sm={12} md={6}>
                                   <p>*{localized.change_email}</p>
                                </Col>
                            </Row>
                        </div>
                        <div className={"or-line"}></div>
                        <div className="setting-profile-input">
                            <h2>{localized.Password}</h2>
                            <Row className="password-field">
                                <FormGroup className="form-group mb-0">
                                    <Label className="col-form-label">
                                        {localized.old_password}
                                    </Label>
                                    <div className="form-input position-relative">
                                        <Field
                                            name="current_password"
                                            type={showPassword.oldPassword ? "text" : "password"}
                                            placeholder={"**********"}
                                            validate={strongPassword}
                                        />
                                        <div className="show-hide" onClick={() => togglePassword("oldPassword")}>
                                            <span className={showPassword.oldPassword ? "" : "show"}/>
                                        </div>
                                    </div>
                                </FormGroup>
                                <Col sm={12} md={6}>
                                    <FormGroup>
                                        <Label for="exampleEmail"> {localized.user_new_password}</Label>
                                        <div className="position-relative">
                                            <Field
                                                name="new_password"
                                                type={showPassword.newPassword ? "text" : "password"}
                                                placeholder={"**********"}
                                                validate={strongPassword}
                                            />
                                            <div className="show-hide" onClick={() => togglePassword("newPassword")}>
                                                <span className={showPassword.newPassword ? "" : "show"}/>
                                            </div>
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col sm={12} md={6}>
                                    <FormGroup>
                                        <Label for="examplePassword">{localized.confirm_password}</Label>
                                        <div className="position-relative">
                                            <Field
                                                name="confirm_password"
                                                type={showPassword.confirmPassword ? "text" : "password"}
                                                placeholder={"**********"}
                                                validate={strongPassword}
                                            />
                                            <div className="show-hide" onClick={() => togglePassword("confirmPassword")}>
                                                <span className={showPassword.confirmPassword ? "" : "show"}/>
                                            </div>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="form-btn-main m-0">
                                <Button className="Save-btn" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? localized.saving : localized.save}
                                </Button>
                            </Row>
                        </div>
                    </form>
                )
            }}
        </Formik>
    );
};

export default PersonalInfo;